import EditIcon from "@mui/icons-material/Edit";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import ReplyIcon from "@mui/icons-material/Reply";
import TwitterIcon from "@mui/icons-material/Twitter";
import {
  Alert,
  AppBar,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Paper,
  Snackbar,
  Tab,
  Tabs,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import moment from "moment";
import { PropTypes } from "prop-types";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SwipeableViews from "react-swipeable-views";
import { AppDataContext } from "../../common/appContext";
import RouteConstants from "../../common/RouteConstants";
import { RoutePermissions, RouteScreens } from "../../common/RoutePermissions";
import { baseUrl } from "../../services";
import { LeaderDashboardService } from "../../services/leaderDashboard.Service";
import { PlayerProfileService } from "../../services/playerProfile.Service";
import Loader from "../../sharedComponents/loader/loader";
import "../adminPreferences/AdminPreferences.css";
import ClubPrograms from "./playerProfileSections/ClubPrograms";
import CollegeExperience from "./playerProfileSections/CollegeExperience";
import GLeagueExperience from "./playerProfileSections/GLeagueExperience";
import HighSchoolDetails from "./playerProfileSections/HighSchoolDetails";
import HSEventsAndRankings from "./playerProfileSections/HSEventsAndRankings";
import InternationalTeamExperience from "./playerProfileSections/InternationalTeamExperience";
import PlayerRanking from "./playerProfileSections/PlayerRanking";
import PlayerCareerStatsContainer from "./playerProfileSections/playerCareerStatsContainer";
import PlayerInterviewContainer from "./playerProfileSections/playerInterviewContainer";
import ProfessionalExperience from "./playerProfileSections/ProfessionalExperience";
import Anthropometry from "./viewProfileSections/Anthropometry";
import BallHandling from "./viewProfileSections/BallHandling";
import FreeThrows from "./viewProfileSections/FreeThrows";
import MidRangeStarDrill from "./viewProfileSections/MidRangeStarDrill";
import MidSideMidDrill from "./viewProfileSections/MidSideMidDrill";
import OffTheDribbleShooting from "./viewProfileSections/OffTheDribbleShooting";
import PlayerDetails from "./viewProfileSections/PlayerDetails";
import ShootingDrillsSummary from "./viewProfileSections/ShootingDrillsSummary";
import SideMidSideDrill from "./viewProfileSections/SideMidSideDrill";
import SituationalWorkouts from "./viewProfileSections/SituationalWorkouts";
import SpotUpShooting from "./viewProfileSections/SpotUpShooting";
import StrengthAndAgility from "./viewProfileSections/StrengthAndAgility";
import ThreePointStarDrill from "./viewProfileSections/ThreePointStarDrill";
import ViewPlayerProfileExport from "./viewProfileSections/ViewPlayerProfileExport";
import ShootingScreen from "./viewProfileSections/ShootingScreen";
import UnitFilterDrawer from "../../sharedComponents/UnitFilterDrawer";
import { isShowUnitDrawerItem } from "../../configs/AppSettings";
import ProDay from "./viewProfileSections/ProDay";

//... Optimized new routes import
import HSEventAndRankingViewUpdate from "./playerProfileSections/HSEventAndRankingViewUpdate";
import CollegeExperienceViewUpdate from "./playerProfileSections/CollegeExperienceViewUpdate";
import HighSchoolDetailsViewUpdate from "./playerProfileSections/HighSchoolDetailsViewUpdate";
import ClubProgramsViewUpdate from "./playerProfileSections/ClubProgramsViewUpdate";
import ProfessionalExperienceViewUpdate from "./playerProfileSections/ProfessionalExperienceViewUpdate";
import GLeagueExperienceViewUpdate from "./playerProfileSections/GLeagueExperienceViewUpdate";
import InternationalTeamExpViewUpdate from "./playerProfileSections/InternationalTeamExpViewUpdate";
import Player5On5Games from "./viewProfileSections/Player5On5Games";

const useStyles = makeStyles((theme) => ({
  bgBlue: {
    height: "131vh",
    background:
      "-webkit-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-moz-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-o-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "-ms-linear-gradient(top, #1d428a 230px, #f6f6f6 20px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
    background:
      "linear-gradient(to bottom, #1d428a 230px, #f6f6f6 21px, #f6f6f6 21px, #f6f6f6 10rem, #f6f6f6 100%)",
  },
  title: {
    //flexGrow: 1,
    fontSize: "1.1rem",
    fontWeight: "450",
    paddingRight: "20px",
  },
  appbarBackground: {
    backgroundColor: "#fff",
    color: "#1d428a",
  },
  actionButtons: {
    padding: "0px 12px 0px 10px",
    height: "40px",
  },
  appbar: {
    backgroundColor: "#f5f5f5",
    color: "#000000",
    "& .Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  paperStyle: {
    // height: "calc(100vh - 149px)",
    //height: "120vh",
  },
  headerText: {
    color: "#1d428a",
  },
  baseButton: {
    minWidth: "40px",
    padding: "0px 20px",
    textTransform: "none",
    border: "1px solid lightgrey",
    boxShadow: "1px 1px 3px 1px lightgrey",
  },
  primaryButton: {
    backgroundColor: "#1d428a",
    color: "white",
    border: "1px solid #1d428a",
    "&:hover": {
      backgroundColor: "#16356f",
    },
  },

  secondaryButton: {
    backgroundColor: "#d32f2f",
    color: "white",
    border: "1px solid #d32f2f",
    "&:hover": {
      backgroundColor: "#b71c1c",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ViewPlayerProfile() {
  const classes = useStyles();
  const theme = useTheme();
  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const [playerData, setPlayerData] = useState({});
  const [selectedTab, setSelectedTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [notes, setNotes] = useState([]);
  const {
    user,
    combineYear,
    selectedEventId,
    setSelectedCombineResultsTab,
    setSelectedCareerStatsTab,
    lengthUnits,
    weightUnits,
    setWeightUnits,
    setLengthUnits,
  } = useContext(AppDataContext);
  let userAppRoles = user.appRoles || [];
  const [eventId, setEventId] = useState(params.eventId);
  const [playeravatar, setPlayerAvatar] = useState(false);
  const [playerCareerStatsData, setPlayerCareerStatsData] = useState({});
  const [anthrosData, setAnthrosData] = useState({});
  const [strengthAndAgilityData, setStrengthAndAgilityData] = useState({});
  const [shootingDrillsData, setShootingDrillsData] = useState({
    shootingDrillsOverallSummary: [],
    spotUpDrillData: [],
    threePointStarDrillData: [],
    midRangeStarDrillData: [],
    sideMidSideDrillData: [],
    midSideMidDrillData: [],
    offTheDribbleShootingData: [],
    freeThrowsData: [],
  });

  const gridSectionStyles = {
    paperStyle: {
      marginTop: "10px",
    },
    gridRoot: {
      "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
        {
          outline: "none",
        },
      "& .MuiDataGrid-main": {
        overflow: "unset",
      },
    },
    gridConfig: {
      pageSize: 10,
      rowHeight: 35,
      headerHeight: 35,
      autoHeight: true,
    },
    gridSectionTitle: {
      fontWeight: "500",
      color: "#1d428a",
      variant: "subtitle1",
    },
    gridActionButton: {
      marginTop: "15px",
      fontSize: "1.5rem",
      cursor: "pointer",
      color: "#1d428a",
      "&:hover": {
        borderRadius: "50%",
        backgroundColor: "#e4e4e4",
      },
    },
    gridCellClassName: "admin-pref-grid-cells",
    sectionTitlePadding: {
      padding: "10px 0px 0px 15px",
    },
    inputSectionPadding: {
      padding: "10px 15px 0px 15px",
      textAlign: "end",
    },
    dataGridPadding: {
      padding: "15px",
    },
    noRowsOverlay: {
      position: "absolute",
      marginTop: "82px",
      marginLeft: "45%",
    },
    cancelButton: {
      textTransform: "none",
      padding: "2px 2px",
      marginRight: "10px",
      minWidth: "20px !important",
      title: "Cancel",
      variant: "outlined",
      cancelIconColor: {
        color: "#c8102e",
      },
    },
    saveButton: {
      textTransform: "none",
      padding: "2px 2px",
      minWidth: "20px !important",
      title: "Save",
      variant: "contained",
    },
  };

  useEffect(() => {
    setEventId(params.eventId);
  }, [params.eventId]);

  useEffect(() => {
    const fetchPreViewPlayersData = async () => {
      // Call getPlayerStatsData
      await getPlayerStatsData();

      LeaderDashboardService.getLeaderBoardNotes().then((response) => {
        const filteredData = response.data.filter(
          (notes) => notes.childID === parseInt(selectedEventId)
        );
        setNotes([
          ...new Map(filteredData.map((m) => [m.childName, m])).values(),
        ]);
      });

      if (user?.loginID && user?.userName) {
        PlayerProfileService.getPlayersProfileData(
          params.playerId,
          params.eventId,
          user.loginID
        ).then((response) => {
          setPlayerData(response.data);
        });

        // Call getAnthrosDataByPlayerId
        PlayerProfileService.getAnthrosDataByPlayerId(
          params.eventId,
          params.playerId,
          user.userName
        ).then((response) => {
          setAnthrosData(response.data);
        });

        // Call getPlayersStrengthAndAgilityData
        PlayerProfileService.getPlayersStrengthAndAgilityData(
          params.eventId,
          params.playerId,
          user.userName
        ).then((response) => {
          setStrengthAndAgilityData(response.data);
        });

        // Call getShootingDrillsOverallSummaryByPlayerId
        PlayerProfileService.getShootingDrillsOverallSummaryByPlayerId(
          params.eventId,
          params.playerId,
          user.loginID
        ).then((response) => {
          setShootingDrillsData((shootingDrillsData) => ({
            ...shootingDrillsData,
            shootingDrillsOverallSummary: response.data,
          }));
        });

        // Define a function to handle repetitive service calls
        const setShootingData = (key, drillId) => {
          PlayerProfileService.getShootingDrillSummaryByPlayerId(
            params.eventId,
            drillId,
            params.playerId,
            user.loginID
          ).then((response) => {
            setShootingDrillsData((shootingDrillsData) => ({
              ...shootingDrillsData,
              [key]: response.data,
            }));
          });
        };

        // Call the function for each type of shooting drill
        const drillMappings = {
          spotUpDrillData: 305,
          threePointStarDrillData: 306,
          midRangeStarDrillData: 302,
          sideMidSideDrillData: 307,
          midSideMidDrillData: 303,
          offTheDribbleShootingData: 304,
          freeThrowsData: 308,
        };

        Object.entries(drillMappings).forEach(([key, drillId]) => {
          setShootingData(key, drillId);
        });
      }
    };

    fetchPreViewPlayersData();
  }, [params.eventId, user?.loginID]);

  async function getPlayerStatsData() {
    try {
      let response = await PlayerProfileService.getPlayerListByCombineYear(
        combineYear,
        params.playerId,
        selectedEventId
      );
      if (response) {
        let data = await response.data;
        setPlayerCareerStatsData(data);
      }
    } catch (e) {
      console.log("Exception", e);
    } finally {
      setLoading(false);
    }
  }

  const handleChange = (event, newValue) => {
    if (newValue === 0) {
      setPlayerAvatar(false);
    } else {
      setPlayerAvatar(true);
    }
    setSelectedTab(newValue);
  };

  const handleChangeIndex = (index) => {
    setSelectedTab(index);
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const editPlayerProfile = () => {
    navigate(
      `/${params.eventId}${RouteConstants.EDIT_PLAYER_PROFILE}/${params.playerId}`,
      {
        state: { playerID: params.playerId },
      }
    );
  };

  const navigateBackPlayerlist = () => {
    navigate(`/${params.eventId}${RouteConstants.PLAYER_LIST}`);
  };

  const navigateBackCombineResult = () => {
    navigate(`/${params.eventId}${RouteConstants.COMBINE_RESULTS}`);
  };

  const navigateBack = () => {
    if (
      location.state &&
      "from" in location.state &&
      location.state.from === "CombineResults"
    ) {
      if ("tab" in location.state && location.state.tab !== "") {
        setSelectedCombineResultsTab(location.state.tab);
        navigate(`/${params.eventId}${RouteConstants.COMBINE_RESULTS}`);
      }
    } else if (
      location.state &&
      "from" in location.state &&
      location.state.from === "CareerStats"
    ) {
      if ("tab" in location.state && location.state.tab !== "") {
        setSelectedCareerStatsTab(location.state.tab);
        navigate(`/${params.eventId}${RouteConstants.CAREER_STATS}`);
      }
    } else if (
      location.state &&
      "from" in location.state &&
      location.state.from === "HomeContainer"
    ) {
      navigate(RouteConstants.HOME);
    } else {
      navigate(`/${params.eventId}${RouteConstants.PLAYER_LIST}`);
    }
  };

  function getSpecifiedNotes(iStationID) {
    switch (iStationID) {
      case 3:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "StrengthAndAgility".toLowerCase()
        );
      case 4:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "Shooting".toLowerCase()
        );
      case 6:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "BallHandling".toLowerCase()
        );
      case 7:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "SituationalWorkOuts".toLowerCase()
        );
      case 8:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "ProDay".toLowerCase()
        );
      default:
        return notes.find(
          (x) =>
            x.childName.replace(/\s/g, "").toLowerCase() ===
            "Anthropometrics".toLowerCase()
        );
    }
  }

  function getNotesBody(iStationID) {
    const notesDetails = getSpecifiedNotes(iStationID);

    return (
      notesDetails?.isActive && (
        <>
          {" "}
          <InfoOutlinedIcon
            style={{ color: "#1d428a", paddingRight: "5px", marginLeft: "5px" }}
          />
          <Typography
            variant="subtitle1"
            className={classes.headerText}
            sx={{ fontSize: "14px" }}
          >
            {notesDetails.description}
          </Typography>
        </>
      )
    );
  }

  return (
    <>
      <Box className={classes.bgBlue}>
        <AppBar position="static" className={classes.appbarBackground}>
          <Toolbar variant="dense" sx={{ justifyContent: "space-between" }}>
            <Grid container spacing={1}>
              <Grid item sm={12} lg={4}>
                <Hidden smDown>
                  <Box display="flex" my={0.8} alignItems="center">
                    <Typography noWrap align="left" className={classes.title}>
                      {/* View Player Profile |&nbsp; */}
                      <span style={{ color: "#c8102e" }}>
                        {playerData.playerName}
                      </span>
                    </Typography>
                    {playeravatar && (
                      <>
                        {" "}
                        <Avatar
                          sx={{
                            bgcolor: "#d3d3d3",
                            width: 40,
                            height: 40,
                          }}
                          src={
                            playerData.headshotURL
                              ? baseUrl(playerData.headshotURL)
                              : ""
                          }
                          alt="basketball"
                        ></Avatar>
                      </>
                    )}
                    {getNotesBody(selectedTab)}
                  </Box>
                </Hidden>
                <Hidden smUp>
                  <Typography
                    noWrap
                    align="left"
                    className={classes.title}
                    sx={{ margin: "5px 10px" }}
                  >
                    View Player Profile
                  </Typography>
                </Hidden>
              </Grid>
              <Grid item sm={12} lg={8}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    columnGap: "10px",
                    padding: "5px",
                    flexWrap: "wrap",
                    [theme.breakpoints.down("sm")]: {
                      justifyContent: "flex-start",
                    },
                  }}
                >
                  <Button
                    size="small"
                    variant="outlined"
                    className={`${classes.baseButton} ${classes.primaryButton}`}
                    onClick={navigateBackPlayerlist}
                  >
                    Back To All Players List
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    className={`${classes.baseButton} ${classes.primaryButton}`}
                    onClick={navigateBackCombineResult}
                  >
                    Back To Combine Result
                  </Button>
                  {RoutePermissions.IsAuthorized(
                    RouteScreens.PlayerProfileEdit,
                    userAppRoles
                  ) ? (
                    <Button
                      size="small"
                      variant="outlined"
                      title="Edit Player Profile"
                      className={`${classes.baseButton} ${classes.primaryButton}`}
                      startIcon={<EditIcon />}
                      onClick={() => editPlayerProfile()}
                    >
                      Edit
                    </Button>
                  ) : (
                    ""
                  )}
                  <Button
                    size="small"
                    variant="outlined"
                    className={`${classes.baseButton} ${classes.secondaryButton}`}
                    startIcon={<ReplyIcon />}
                    onClick={navigateBack}
                  >
                    Back
                  </Button>

                  <ViewPlayerProfileExport
                    playerData={playerData}
                    playerCareerStatsData={playerCareerStatsData}
                    anthrosSummaryData={anthrosData}
                    strengthAndAgilityData={strengthAndAgilityData}
                    shootingDrillsData={shootingDrillsData}
                  />
                </Box>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <Container maxWidth={false}>
          <Grid container pt={2} pb={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Grid container>
                <Grid item lg xs={12}>
                  <Paper elevation={8} square>
                    <Box
                      component="div"
                      display="flex"
                      flexGrow={1}
                      flexDirection="column"
                      className={classes.paperStyle}
                    >
                      <AppBar
                        position="static"
                        className={classes.appbar}
                        sx={{
                          borderTopLeftRadius: "15px !important",
                          borderTopRightRadius: "15px !important",
                        }}
                      >
                        <Hidden mdUp>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="scrollable"
                            aria-label="full width tabs example"
                            // selectionFollowsFocus
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Profile"
                              {...a11yProps(0)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Career Stats"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(2)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Strength+Agility"
                              {...a11yProps(3)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(4)}
                            />
                            {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Percentile Rankings"
                              {...a11yProps(5)}
                            /> */}
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Interview"
                              {...a11yProps(5)}
                            />
                            {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Ball Handling"
                              {...a11yProps(5)}
                            /> */}

                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Situational Workouts"
                              {...a11yProps(6)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Pro Day"
                              {...a11yProps(7)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="5 On 5 Games"
                              {...a11yProps(8)}
                            />
                          </Tabs>
                        </Hidden>
                        <Hidden mdDown>
                          <Tabs
                            scrollButtons
                            allowScrollButtonsMobile
                            value={selectedTab}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="inherit"
                            variant="standard"
                            aria-label="full width tabs example"
                          >
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Profile"
                              {...a11yProps(0)}
                            ></Tab>
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Career Stats"
                              {...a11yProps(1)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Anthropometry"
                              {...a11yProps(2)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Strength+Agility"
                              {...a11yProps(3)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Shooting Drills"
                              {...a11yProps(4)}
                            />
                            {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Percentile Rankings"
                              {...a11yProps(5)}
                            /> */}
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Player Interview"
                              {...a11yProps(5)}
                            />
                            {/* <Tab
                              sx={{ textTransform: "none" }}
                              label="Ball Handling"
                              {...a11yProps(5)}
                            /> */}
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Situational Workouts"
                              {...a11yProps(6)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="Pro Day"
                              {...a11yProps(7)}
                            />
                            <Tab
                              sx={{ textTransform: "none" }}
                              label="5 On 5 Games"
                              {...a11yProps(8)}
                            />
                          </Tabs>
                        </Hidden>
                      </AppBar>
                      <SwipeableViews
                        className={classes.swipeView}
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={selectedTab}
                        onChangeIndex={handleChangeIndex}
                      >
                        {/* Tab 1 */}
                        <TabPanel
                          value={selectedTab}
                          index={0}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 15px 10px",
                            }}
                          >
                            <PlayerDetails
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={playerData ? playerData : []}
                              agentDetails={
                                playerData.agent ? playerData.agent : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                              playerData={playerData}
                            />
                            <CollegeExperienceViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.college ? playerData.college : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />
                            <HighSchoolDetailsViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.highSchool
                                  ? playerData.highSchool
                                  : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />
                            <ClubProgramsViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.aauClub ? playerData.aauClub : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />
                            <ProfessionalExperienceViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.intProfExperience
                                  ? playerData.intProfExperience
                                  : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />
                            <GLeagueExperienceViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.gLeagueExperience
                                  ? playerData.gLeagueExperience
                                  : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />
                            <InternationalTeamExpViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              gridPropsData={
                                playerData.nationalIntExp
                                  ? playerData.nationalIntExp
                                  : []
                              }
                              styles={gridSectionStyles}
                              viewProfile={true}
                            />

                            <HSEventAndRankingViewUpdate
                              eventId={params.eventId}
                              playerID={params.playerId}
                              highSchoolEventsData={
                                playerData.highSchoolEvents
                                  ? playerData.highSchoolEvents
                                  : []
                              }
                              rankingsData={
                                playerData.ranking ? playerData.ranking : []
                              }
                              styles={gridSectionStyles}
                              playerData={playerData}
                              viewProfile={true}
                              user={user}
                            />
                          </Box>
                        </TabPanel>
                        {/* Tab 2 */}
                        <TabPanel
                          value={selectedTab}
                          index={1}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 10px 10px",
                            }}
                          >
                            <PlayerCareerStatsContainer
                              setLoading={setLoading}
                              setAlert={setAlert}
                              setAlertType={setAlertType}
                              setAlertMessage={setAlertMessage}
                            />
                          </Box>
                        </TabPanel>
                        {/* Tab 3 */}
                        <TabPanel
                          value={selectedTab}
                          index={2}
                          dir={theme.direction}
                        >
                          <Anthropometry
                            // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                        </TabPanel>
                        {/* Tab 4 */}
                        <TabPanel
                          value={selectedTab}
                          index={3}
                          dir={theme.direction}
                        >
                          <StrengthAndAgility
                            eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                        </TabPanel>
                        {/* Tab 5 */}
                        <TabPanel
                          value={selectedTab}
                          index={4}
                          dir={theme.direction}
                        >
                          <ShootingScreen
                            EventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          {/* <ShootingDrillsSummary
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <SpotUpShooting
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <ThreePointStarDrill
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <MidRangeStarDrill
                        //  eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <SideMidSideDrill
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <MidSideMidDrill
                           //eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <OffTheDribbleShooting
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          />
                          <FreeThrows
                           // eventId={params.eventId}
                            playerID={params.playerId}
                            styles={gridSectionStyles}
                          /> */}
                        </TabPanel>
                        {/* Tab 6 */}
                        {/* <TabPanel
                          value={selectedTab}
                          index={5}
                          dir={theme.direction}
                        >
                          <div
                            style={{ paddingTop: "20%", textAlign: "center" }}
                          >
                            Percentile Rankings
                          </div>
                        </TabPanel> */}
                        {/* Tab 7 */}
                        <TabPanel
                          value={selectedTab}
                          index={5}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 10px 10px",
                            }}
                          >
                            <PlayerInterviewContainer
                              setLoading={setLoading}
                              setAlert={setAlert}
                              setAlertType={setAlertType}
                              setAlertMessage={setAlertMessage}
                            />
                          </Box>
                        </TabPanel>
                        {/* <TabPanel
                          value={selectedTab}
                          index={6}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 10px 10px",
                            }}
                          >
                            <BallHandling
                              playerID={params.playerId}
                              setLoading={setLoading}
                            />
                          </Box>
                        </TabPanel> */}
                        <TabPanel
                          value={selectedTab}
                          index={6}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 10px 10px",
                            }}
                          >
                            <SituationalWorkouts
                              playerID={params.playerId}
                              setLoading={setLoading}
                            />
                          </Box>
                        </TabPanel>
                        <TabPanel
                          value={selectedTab}
                          index={7}
                          dir={theme.direction}
                        >
                          <Box
                            sx={{
                              overflowY: "scroll",
                              padding: "0px 5px 10px 10px",
                            }}
                          >
                            <ProDay
                              playerID={params.playerId}
                              setLoading={setLoading}
                            />
                          </Box>
                        </TabPanel>
                        <TabPanel
                          value={selectedTab}
                          index={8}
                          dir={theme.direction}
                        >
                          <Player5On5Games
                            playerID={params.playerId}
                            setLoading={setLoading}
                          />
                        </TabPanel>
                      </SwipeableViews>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Loader isLoading={loading} />
      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={handleAlertClose}
      >
        <Alert
          onClose={handleAlertClose}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
      {isShowUnitDrawerItem && (
        <UnitFilterDrawer
          lengthUnits={lengthUnits}
          weightUnits={weightUnits}
          setLengthUnits={setLengthUnits}
          setWeightUnits={setWeightUnits}
        />
      )}
    </>
  );
}
